import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, Droplets, Info, ArrowRight } from 'lucide-react';
import Modal from '../ui/Modal';
import type { Plant } from '../../types/plant';

interface CompanionPlantModalProps {
  isOpen: boolean;
  onClose: () => void;
  plant: {
    id: string;
    name: string;
    scientific_name: string;
    image_url: string;
    sunlight_requirements?: string;
    water_requirements?: string;
  };
  benefits?: string;
}

export default function CompanionPlantModal({ isOpen, onClose, plant, benefits }: CompanionPlantModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="">
      <div>
        <div className="flex gap-4 mb-6">
          <img
            src={plant.image_url}
            alt={plant.name}
            className="w-24 h-24 rounded-lg object-cover"
          />
          <div>
            <h2 className="text-xl font-bold">{plant.name}</h2>
            <p className="text-gray-600 italic">{plant.scientific_name}</p>
          </div>
        </div>

        {benefits && (
          <div className="mb-6">
            <div className="flex items-start gap-2">
              <Info className="h-5 w-5 text-primary-500 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-medium mb-1">Companion Benefits</h3>
                <p className="text-gray-600">{benefits}</p>
              </div>
            </div>
          </div>
        )}

        {(plant.sunlight_requirements || plant.water_requirements) && (
          <div className="grid grid-cols-2 gap-4 mb-6">
            {plant.sunlight_requirements && (
              <div className="flex items-center gap-2">
                <Sun className="h-5 w-5 text-primary-500" />
                <div>
                  <p className="text-sm text-gray-600">Sunlight</p>
                  <p className="font-medium">{plant.sunlight_requirements}</p>
                </div>
              </div>
            )}
            {plant.water_requirements && (
              <div className="flex items-center gap-2">
                <Droplets className="h-5 w-5 text-primary-500" />
                <div>
                  <p className="text-sm text-gray-600">Water</p>
                  <p className="font-medium">{plant.water_requirements}</p>
                </div>
              </div>
            )}
          </div>
        )}

        <Link
          to={`/plants/${plant.id}`}
          className="flex items-center justify-center gap-2 w-full bg-primary-500 text-white py-3 rounded-lg hover:bg-primary-600 transition-colors"
        >
          <span>View Full Details</span>
          <ArrowRight className="h-5 w-5" />
        </Link>
      </div>
    </Modal>
  );
}